import AudioAcceptsIcon from '@/assets/images/common/svg/audio-accepts.svg?react';
import VideoAcceptsIcon from '@/assets/images/common/svg/video-accepts.svg?react';
import AcceptsLoadingIcon from '@/assets/images/common/svg/accepts-loading.svg?react';
import { ChatMessagePayloadType } from '@/contexts/chat/scripts/hooks/useChatMessages/types';
import { useColorAnalyzer } from '@/scripts/hooks/useColorAnalyzer';
import { useChatContext } from '@/contexts/chat/context';
import IgnoreCallIcon from './images/ignore-icon.svg?react';
import VoiceIcon from './images/voice-icon.svg?react';
import styles from './index.module.scss';

const NotificationContentGroup = () => {
  const {
    chatMediaCall: { chatMediaInfo },
    mediaLoading,
    mediaJoin,
    mediaDeclined,
  } = useChatContext();
  const [selected, setSelected] = useState('' as 'accept' | 'decline');

  const payload_type = useMemo(() => chatMediaInfo?.payload_type, [chatMediaInfo]);

  const callMembersLength = useMemo(
    () => chatMediaInfo?.callMembers?.length ?? 0,
    [chatMediaInfo?.callMembers]
  );

  const bgColor = useColorAnalyzer(chatMediaInfo?.chat?.user?.avatar, {
    format: 'rgb',
    samplingStep: 8,
    // alpha: 0.5,
  });

  const handleDeclined = useCallback(() => {
    setSelected('decline');
    mediaDeclined();
  }, [mediaDeclined]);

  const handleAccept = useCallback(async () => {
    setSelected('accept');
    await mediaJoin();
  }, [mediaJoin]);

  return (
    <div className={styles.notificationContent} style={{ backgroundColor: bgColor }}>
      <div className={cls(styles.groupSendInfo)}>
        <MyAvatar
          className={styles.avatar}
          src={chatMediaInfo?.chat?.avatar as string}
          category={chatMediaInfo?.chat?.category}
          info={chatMediaInfo?.chat?.user}
        />
        <div className={cls(styles.info, styles.groupInfo)}>
          <div className={styles.name}>
            {/* {chatMediaInfo?.callMembers?.map((member) => member.name).join('、')} */}
            {chatMediaInfo?.chat?.name}
          </div>
          <div className={styles.content}>
            <div className={cls(styles.tipsTopText, styles.tipsText)}>
              <span className={styles.callIcon}>
                <VoiceIcon />
              </span>
              <span>{chatMediaInfo?.caller?.name} is ringing...</span>
            </div>
            {callMembersLength > 1 && (
              <div className={styles.tipsText}>
                {callMembersLength - 1} others are also being called...
              </div>
            )}
          </div>
          <div className={styles.members}>
            {chatMediaInfo?.callMembers
              ?.slice(0, 3)
              .map((member) => (
                <MyAvatar
                  className={styles.membersAvatar}
                  src={member.avatar as string}
                  key={member.userId}
                  info={member}
                />
              ))}
            {callMembersLength > 3 && (
              <Badge
                count={callMembersLength - 3}
                overflowCount={99}
                color="rgba(0, 0, 0, 0.20)"
              ></Badge>
            )}
          </div>
        </div>
        <div className={styles.operation}>
          {selected !== 'accept' && (
            <div className={styles.operateBtn}>
              <IgnoreCallIcon onClick={handleDeclined} />
              <div className={styles.operateTxt}>Ignore</div>
            </div>
          )}
          {selected !== 'decline' && (
            <div className={styles.operateBtn}>
              {mediaLoading ? (
                <AcceptsLoadingIcon></AcceptsLoadingIcon>
              ) : payload_type === ChatMessagePayloadType.MEDIA_AUDIO_CALL ? (
                <AudioAcceptsIcon onClick={handleAccept}></AudioAcceptsIcon>
              ) : (
                <VideoAcceptsIcon onClick={handleAccept}></VideoAcceptsIcon>
              )}
              <div className={styles.operateTxt}>Join</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationContentGroup;
